import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://gutrlwvqdrnninroeimq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd1dHJsd3ZxZHJubmlucm9laW1xIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwMTE1MTYsImV4cCI6MjA4MTU4NzUxNn0.VN0DWIJtLWaoS_h9M8qq_wNyf9UsuEW5NsGhEK6eUts';

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.'
  );
}

export const supabase = supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;
